export const websiteEnv = {
  // 英文站点
  isUnitedStates: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'us',
  isUnitedKingdom: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'uk',
  isCanada: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ca',
  isAustralia: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'au',
  isIreland: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ie',
  isNewZealand: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'nz',
  isGermanyEnglish: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'de_en',
  isSingapore: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'sg',
  // 非英文站点
  isFrance: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'fr',
  isItaly: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'it',
  isGermany: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'de',
  isCanadaFrench: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ca_fr',
  isSweden: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'se',
  isSpain: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'es',
  isMexico: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'mx',
  isSwitzerland: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'ch',
  isAustria: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'at',
  isNetherlands: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'nl',
  isBelgium: process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'be',
};
